const zhtw = {
    "Home": "銀行首頁",
    "Liquidity": "流動資金",
    "Swap": "資產兌換",
    "Stake": "質押獲利",
    "Portfolio": "資產總覽",
    "Connect Wallet": "連接錢包",
    "Disconnect": "退出錢包",
    "Welcome to TiFi Bank!": "歡迎來到TiFi銀行!",
    "The First Decentralized Bank for Allverse": "這裡是第一個面向全宇宙的去中心化交易所",
    "Exchange Cryptos with other Cryptos": "用加密貨幣兌換其他的加密貨幣",
    "GO TO SWAP": "去兌換",
    "Enjoy Earning by Providing Liquidity": "向流動池注入資金，分享利息回報",
    "GO TO LIQUIDITY": "注入資金",
    "Provide Observerbility of Pool Portfolio": "總覽各個流動資金池",
    "GO TO PORTFOLIO": "去看看",
    "We appeciate for any feedbacks, please submit your feedbacks": "我們真誠的感謝您的任何反饋，您可以在這裡提交反饋意見",
    "here": "(點擊這裡)",
    ", and you will have a chance to get TIFI airdrop!": "，您就有機會獲得TIFI空投獎勵！",
    "Haven’t got a crypto wallet yet?": "還不知道怎麼用加密貨幣錢包？",
    "Learn How to Connect": "了解一下怎麼用！",
    "More": "其他錢包",
    "Price Chart": "價格走勢圖",
    "The market price chart from public exchanges. It shows the historical prices and the latest price in the chart may not be the same as the price show on the right panel of the page. The data chart may be incomplete due to data source provider.": "該走勢圖基於公開數據源顯示了歷史數據和當前價格，由於數據的實時性，該圖上的價格可能和右邊顯示的價格略有不同。由於公共數據源的問題，該走勢圖數據可能會不完整。",
    "24H": "24小時",
    "7D": "7天",
    "14D": "14天",
    "30D": "30天",
    "1Y": "一年",
    "Term of Use": "使用條款",
    "Privacy Policy": "隱私條款",
    "Cookies Policy": "Cookie條款",
    "Disclaimer": "免責聲明",
    "FAQ": "常見問題",
    "Contact Us": "聯繫我們",
    "All rights reserved.": "保留所有權利",
    "Balance": "餘額",
    "The number is invalid, maybe too big?": "不是有效的數字，是不是太大了？",
    "You are not on the BSC main net. Please switch to the main net.": "您沒有連上幣安智能鏈（BSC），請連接。",
    "You have selected the same tokens, please select a different token.": "您選了兩個一樣的幣，請選擇不同的幣。",
    "The pair doesn't exist, please select another pair.": "資金池不存在，請選擇其他的加密貨幣配對。",
    "Not enough balance for the transaction.": "非常抱歉，您的餘額不足以完成這次交易。",
    "Transaction rejected by user.": "您拒絕了這次交易。",
    "Transaction Submitted!": "交易已提交！",
    "Check Transaction on BSCScan": "在BSCScan上查看該交易。",
    "Swap Success!": "兌換成功！",
    "Approved, now you can swap!": "成功批准，您現在可以兌換了！",
    "Approval Request submitted. Please hold on.": "申請批准已提交，請稍候。",
    "successful added": "添加成功",
    "added failed": "添加失敗",
    "Cannot find address of": "無法找到該幣的地址：",
    ", have you connected MetaMask?": "，請連接到MetaMask。",
    "copied": "已拷貝！",
    "Price": "價格",
    "per": "每",
    "Price Impact Too High": "該交易對價格的影響太高！",
    "Insufficient Liquidity for This Trade": "沒有足夠的資金完成該交易！",
    "Insufficient Balance": "餘額不足！",
    "Swap Fee": "兌換交易手續費",
    "Swap Fee is 0.2%, where:": "手續費為0.2%，其中：",
    "0.18% is paid to LP Providers": "0.18%付給流動資金的提供者",
    "0.02% to the TiFi treasury": "0.02%為TiFi的項目資金",
    "Price Impact": "該交易對價格的影響",
    "The difference between the market price and estimated price due to trade size.": "根據交易量的大小，預估的價值和目前的市場價值會有所差別。",
    "Route": "兌換路徑",
    "Routing through these tokens resulted in the best price for your trade.": "為了以最低價值兌換幣，系統找到的最佳兌換路徑。",
    "TIFI Sell Fee": "TIFI賣出手續費",
    "There is 2% of fee when selling TIFI, check ": "賣出TIFI時有2%的手續費，請參看",
    "TiFi Token Whitepaper": "TIFI白皮書",
    " for more details.": "以了解更多信息",
    "TIFI Buy Fee": "TIFI買入手續費",
    "There is 1% of fee when buying TIFI, check ": "買入TIFI時有1%的手續費，請參看",
    "Swap from": "您想用什麼幣兌換？",
    "Swap to": "您想兌換成什麼幣？",
    "Select the first token": "請選擇第一個幣",
    "Select the second token": "請選擇第二個幣",
    "Only tokens that paired with ": "只有和",
    " are listed": "有配對的幣會列出來",
    "The following tokens are listed in TiFi Bank": "TiFi銀行目前支持以下代幣",
    "Stay Tuned!": "敬請期待！",
    "TiFi Bank Portfolio Page will be available in August 2022!": "TiFi銀行的資金總覽功能會在2022年八月推出！",
    "TiFi Bank Staking will be available in August 2022!": "TiFi銀行的質押獲利功能會在2022年八月推出！",
    "Your Liquidity": "您提供的流動資金",
    "Connect to a wallet to view your liquidity.": "連接錢包可以查看您提供的流動資金。",
    "Add Liquidity": "添加流動資金",
    "Enter Amount": "請輸入金額",
    "Approved! Now you can remove liquidity.": "已批准，現在您可以從池子裡移除流動資金！",
    "Liquidity Removal Success!": "您已成功從池子裡移除流動資金！",
    "Remove": "移除",
    "liquidity": "流動資金",
    "To receive": "您會收到",
    "and": "和",
    "Amount (LP Tokens to Remove / Total)": "流動資金池代幣的數量（要移除的量/總量）",
    "Max": "全部",
    "You will Receive": "您會收到",
    "Pooled": "池子裡的",
    "Enable": "批准",
    "Liquidity Pool Token Balance": "流動資金池代幣餘額",
    "Share of pool": "佔資金池的比例",
    "Add liquidity instead": "添加流動資金",
    "No liquidity found": "目前沒有流動資金",
    "Approved! Now you can add liquidity.": "已批准，現在您可以向池子裡添加流動資金！",
    "Liquidity Provision Success!": "流動資金添加成功！",
    "Tip: By adding liquidity you'll earn 0.18% of all trades on this pair proportional to your share of the pool. Fees are added to the pool, accrue in real time and can be claimed by withdrawing your liquidity.": "提示：向池子中添加流動資金後，您會按持有的資金池比例獲得交易量0.18%的獎勵，該獎勵會根據交易的發生實時積累，您可以在取走資金時獲得這些獎勵。",
    "Input": "提供",
    "Select a token": "請選擇一種幣",
    "Price and pool share": "價格和池子佔有比例",
    "Insufficent balance": "餘額不足",
    "Supply": "提供資金",
    "Connect to a wallet to add liquidity.": "連接錢包以提供流動資金。",
    "Insufficient balance to perform this transaction.": "因餘額不足交易無法執行。",
    "Stake TIFI to earn TIFI and WBNB with high APY": "質押TIFI以獲得高年利率的TIFI和WBNB回報",
    "Pool Analytics": "流動資金信息",
    "Stake Analytics": "質押獲利信息",
    "Your Stake": "您的質押記錄",
    "TIFI APY Last 24 Hours": "24小時TIFI年利率",
    "WBNB APY Last 24 Hours": "24小時WBNB年利率",
    "The TIFI APY when staking TIFI based on the transaction of last 24 hours. It is updated every day at 01:00 UTC.": "根據前24小時的交易量計算出的質押TIFI獲得TIFI的年利率，該利率每天更新一次，更新時間為格林尼治標準時間凌晨1點。",
    "The WBNB APY when staking TIFI based on the transaction of last 24 hours. This is the APY of average case. It is updated every day at 01:00 UTC.": "根据前24小时的交易量计算出的质押TIFI获得WBNB的年利率，该利率反应了所有质押记录的平均情况，该利率每天更新一次，更新时间为格林尼治标准时间凌晨1点。",
    "TIFI APY Last 30 Days": "30天TIFI年利率",
    "WBNB APY Last 30 Days": "30天WBNB年利率",
    "The average TIFI APY when staking TIFI based on the transaction of last 30 days. It is updated every day at 01:00 UTC.": "根據前30天的交易量計算出的質押TIFI獲得TIFI的年利率，該利率每天更新一次，更新時間為格林尼治標準時間凌晨1點。",
    "The WBNB APY when staking TIFI based on the transaction of last 30 days. This is the APY of average case. It is updated every day at 01:00 UTC.": "根據前30天的交易量計算出的質押TIFI獲得WBNB的年利率，該利率反應了所有質押記錄的平均情況，該利率每天更新一次，更新時間為格林尼治標準時間凌晨1點。",
    "Connect to a wallet to view your stake records.": "請連接錢包以查看質押記錄。",
    "Stake TIFI": "質押TIFI",
    "Go to TiFi.net": "訪問TiFi.net",
    "TiFi Bank Home Page": "TiFi銀行首頁",
    "View TIFI on CoinMarketCap": "訪問TIFI的CoinMarketCap頁面",
    "No stake record found": "找不到您的質押記錄",
    "Notice: TiFi Bank charges 0.02 BNB of transaction fee for every stake, there are no fees when unstake. To receive the rewards, you have to stake TIFI at least 30 days. You will also get WBNB reward if you stake for more than 180 days.": "請注意：TiFi銀行對每次質押收取0.02BNB的手續費，提取時不會收手續費。您必須質押TIFI超過30天才能得到利息。您在質押180天后還會得到WBNB利息。",
    "Connect to a wallet to stake.": "請連接錢包開始質押",
    "Staked on": "質押時間",
    "Unstake now, you will get": "現在取出，您會得到",
    ", you will get at least": "，您至少會得到",
    "After": "在此時間之後",
    "Unstake": "取出",
    "Total Amount of TIFI staked on ": "您在該時間質押的TIFI數量 ",
    "TIFI Staked": "質押的TIFI",
    "Reward": "獎勵",
    "Notice: You are not getting the full reward of extra TIFI and WBNB because the staking time is less than 180 days!": "注意：因為該質押記錄少於180天，因此您不能得到所有的TIFI獎勵和WBNB獎勵！",
    "Enable Stake": "開啟質押功能",
    "Approved! Now you can stake.": "質押功能已開啟，您現在可以質押了!",
    "Click on the column name to sort pairs by its volume or APR.": "點擊每列的名稱，記錄會按照流動資金量和年收益率排序。",
    "Pools": "流動資金池",
    "Name": "名稱",
    "APY": "年收益率",
    "Action": "添加流動資金",
    "Track the earning trends for staking": "以下圖表為質押獲利跟踪記錄",
    "Stake APY Charts": "質押獲利年收益表",
    "TIFI Stake Reward APY": "TIFI質押年收益",
    "TIFI Reflection Reward APY": "TIFI持有獎勵(Reflection)年收益",
    "WBNB Stake Reward APY": "WBNB年收益",
    "Note: The TIFI APY chart shows the comparison of TIFI reflection rate (holding TIFI in wallet) and TIFI staking rate. Both APY rates are determined by trading volume, but the staking takes extra trading fees to pay the earnings.": "注意：TIFI質押年收益表比較了TIFI持有收益（Reflection Reward）和質押收益。兩者都取決於交易量，但有更多的交易費作為質押的收益，所以質押會有更多的收益。",
    "Note: The WBNB APY chart shows the APY earning rate for average users. You can only get the WBNB earning after your have staked TIFI for more than 180 days.": "注意：WBNB的收益率表顯示的收益是整體的平均情況。您會在質押TIFI 180天之後獲得WBNB獎勵。",
    "GO TO STAKE": "去質押",
    "Notice: The amounts showing below is based on the rewards TiFi Bank collected so far. It is accumulating as more transactions that will happen on blockchain network.": "請注意：下面顯示的代幣數量是基於當前TiFi銀行的目前收集的獎勵計算的，您獲得的獎勵會隨著區塊鍊網絡上的交易量不斷增長。",
    "The total value of tokens in staking pool, it is updated hourly.": "質押池裡所有代幣的價值，每小時更新一次",
    "Win": "贏取獎金",
    "Approved! Now you can play Lucky Bags!": "福袋已開啟！您現在可以玩了。",
    "Lucky Bags": "福袋",
    "Buy mystery shopping bags and win TIFI!": "買福袋，贏TIFI！",
    "Jackpot": "頭獎",
    "The amount TIFI in Jackpot prize pool, bet more and you will have higher chance to win!": "頭獎獎池的TIFI數量，投注次數越多，您越有機會獲得頭獎！",
    "You Have Won": "您已赢得",
    "TiFi Token you have won in total so far.": "您目前已贏得的所有TIFI數量。",
    "Approve to Play!": "開啟福袋功能",
    "Select your bet": "請選擇投注金額",
    "Rules": "規則",
    "How To Play": "如何玩福袋：",
    "Connect Wallet.": "連接錢包。",
    "Select your bet, it cost from 1x (1 USD worth of TIFI) to 100x (100 USD worth of TIFI).": "選擇賭注，賭金從1倍（價值1美元的TIFI）到100倍（價值100美元的TIFI）。",
    "Deposit TiFi Token to your bag, this game will use the token in your bag for bet.": "向您的袋子中存入TIFI, 該遊戲會用您袋子中的TIFI作為賭金。",
    "Choose your Lucky Bag from 12 unrevealed bags. The prizes in Lucky Bags are random.": "從12個神秘的購物袋中選擇一個福袋。每個福袋都有一定的TIFI獎勵，TIFI獎勵是隨機的。",
    "Win prize on the spot! Everyone has the chance to win Jackpot! Prizes are paid via TIFI.": "等十幾秒鐘就當場開獎！每個人都有機會得頭獎！獎金以TIFI的形式支付到你的錢包。",
    "Bet Amount": "賭注金額",
    "Bets are paid via TIFI, 1x is 1 USD worth of TIFI, 2x is 2 USD worth of TIFI, and so on.": "賭注通過TIFI支付, 1x（一倍）賭注是價值1美元的TIFI，2x（二倍）賭注是價值2美元的TIFI，以此類推。",
    "Here are the bet amounts based on current rate of TIFI:": "這是根據當前TIFI的價格算出的TIFI賭注數量：",
    "Prizes": "奖金",
    "Prizes are reflected in the Balance in Your Bag immediately after your bet. You can withdraw TIFI from your bag to your wallet any time.": "每局結束後獎金會立即存入您的袋子中，您可以在任何時間將您袋子中的TIFI存入您的錢包中。",
    "Usually it takes less than 30 seconds to reveal the prize after you selected the Lucky Bag.": "在您選擇福袋之後，通常30秒之內就會揭曉獲獎獎項。",
    "There are 6 prizes of Lucky Bags:": "福袋遊戲有六種獎項：",
    "Bronze Bag": "銅色袋子",
    "Silver Bag": "銀色袋子",
    "Golden Bag": "金色袋子",
    "Sapphire Blue Bag": "藍寶石袋子",
    "Ruby Red Bag": "紅寶石袋子",
    "Win 10% of bet amount.": "獎勵賭注金額的10%。",
    "Win 50% of bet amount.": "獎勵賭注金額的50%。",
    "Win 200% of bet amount.": "獎勵賭注金額的200%。",
    "Win 500% of bet amount.": "獎勵賭注金額的500%。",
    "Win 1000% of bet amount.": "獎勵賭注金額的1000%。",
    "You will win all TIFI from accumulated Jackpot pool.": "您會贏得頭獎獎池中的所有TIFI。",
    "Top Winners!": "獲獎排行榜！",
    "Message from Lucky Bag": "福袋消息",
    "Network error, make sure you have internet connection!": "網絡錯誤，請保證您已連接到網絡！",
    "Sorry, you don't have sufficient balance to bet!": "抱歉，您沒有足夠的賭注！",
    "Welcome! Please connect wallet first.": "歡迎！請先連接錢包。",
    "Oops! Something wrong when bet, the TIFI you have paid has been refunded.": "抱歉，下注時出現錯誤，賭金已返還。",
    "You have selected the bag:": "您選擇了下面這個福袋：",
    "Please select your Lucky Bag!": "請您選擇福袋",
    "Congratulations!": "恭喜！",
    "You have won a ": "您贏得了一個",
    "Hold on! Your lucky bag will be revealed in a few seconds!": "請稍候，您的福袋將在幾秒鐘後開獎！",
    "You've won ": "您已經贏得",
    "You are paying ": "您在花費",
    " for a Lucky Bag!": "來購買一個福袋！",
    "Bet again!": "再玩一次！",
    "Lucky Bags Statistics": "福袋數據統計",
    "The statistics about Top Winners and Jackpot Winners": "福袋獲獎排行榜和頭獎獲得者",
    "Play Now!": "去玩福袋！",
    "Total Winners:": "獲獎者數量：",
    "Top Winners": "獲獎排行榜",
    "Jackpot Prize Pool: ": "頭獎獎池:",
    "Jackpot Winners": "頭獎獲得者",
    "Winner": "獲獎者",
    "Total Win ($TIFI)": "總計獲得TIFI數量",
    "Jackpot ($TIFI)": "頭獎TIFI數量",
    "Winning Date": "獲獎日期",
    "No Records Yet.": "暫無記錄",
    "Balance in Your Bag": "您袋子中的餘額",
    "Click Deposit Button Below to Add TIFI & Play!": "點擊下面的“存入”按鈕開始！",
    "Deposit": "存入",
    "Withdraw": "取出",
    "Approve the deposit first (no need to do every time), enter the amount and Deposit to Your Bag!": "在錢包裡批准向您的袋子中存入TIFI（不需要每次都做），輸入金額後點擊\"存入您的袋子\"。",
    "You can bet many times as long as there are sufficient TIFI in your bag. If current bet amount is less than the balance in your bag, you have to deposit more TIFI to continue.": "只要您的袋子中有足夠的TIFI就可以下注。如果您的一把的賭金大於袋子的餘額，您需要向袋子中存入更多的TIFI才能繼續玩。",
    "Withdraw Submitted!": "取出請求成功提交！",
    "Withdraw Success!": "取出成功！",
    "Deposit Submitted!": "存入請求成功提交！",
    "Deposit Success!": "存入成功！",
    "Deposit To Your Bag!": "存入您的袋子!",
    "Sorry you don't have enough TIFI for bet, please deposit more TIFI to your bag!": "抱歉，您的賭金餘額不足，請向您的袋子中存入更多的TIFI。",
    "Total Amount of TIFI you want to withdraw": "您想取出的TIFI數量",
    "Withdraw To Your Wallet!": "把TIFI取出放到我的錢包裡！",
    "TVL in Staking Pool": "質押池資產總價值",
    "Crypto Loan": "加密貨幣資產借貸",
    "Supply crypto assets to earn interests and get fast loan without credit check.": "提供加密貨幣資金獲取利息，不用查信用快速獲得貸款。",
    "Supplied Assets": "提供資金",
    "Total value of your supplied assets.": "您提供的資金總價值。",
    "N/A": "暫無數據",
    "Max. Borrow": "最多可借出價值",
    "This value is estimation of the maximum asset value you can borrow. Because of fluctuated market, you may not be able to borrow so much.": "您可借出資產的總價值。注意：該數據為估計值，由於市場的波動性，您可能無法借出這麼多價值的加密貨幣資產。",
    "Current Borrow": "当前已借出价值",
    "The current value of assets you have borrowed.": "當前已借出價值",
    "Health Level": "資產健康等級",
    "The health level of your account. You need pay attention to your health level all the time. If your health level is WARNING or UNHEALTHY, you need pay your debts as soon as possible. If health level is UNHEALTHY, you cannot borrow any assets from this platform.": "您的賬戶的資產健康等級。您需要時刻留意您的資產健康等級，如果您的資產健康狀況是“危險”或者“不健康”，您需要盡快償還您的貸款。如果您的健康狀況是“不健康”，您將不能從TiFi銀行中貸款。",
    "Connect to a wallet to view assets.": "連接錢包查看資產。",
    "Lending APY": "借出年化收益率",
    "Borrowing APY": "貸款年化收益率",
    "The amount of the tokens in the reserve plus tokens borrowed": "借出和借貸池中加密貨幣總和",
    "Available": "可借出",
    "The maximum amount of tokens that users can borrow from the pool.": "用戶最多可以藉出的加密貨幣數量",
    "Credit": "信用額",
    "The balance of amount of token you have deposited.": "您當前存入的加密貨幣數量（含利息）。",
    "Debt": "債務額",
    "The balance of the amount of token you have borrowed.": "您借出需要還的的加密貨幣數量（含利息）",
    "Borrow": "借出",
    "Repay": "還款",
    "No lending pool found": "無法找到貸款資金池",
    "Please connect to wallet first!": "請您先連接錢包！",
    "Borrow Success!": "借款成功！",
    "Borrow Quota": "借款額度",
    "The maxium value of assets you can borrow in the selected token.": "您最多可以藉出該加密貨幣的數量。",
    "Pool Balance": "資金池餘額",
    "The current balance in lending pool.": "當前借貸資金池中的餘額。",
    "Notice: WBNB is the wrapper token of BNB, you can convert between BNB and WBNB without transaction fee at ": "注意：WBNB是封裝BNB的BEP20標準貨幣，如果您要進行兌換，請",
    "Maximum": "上限",
    "Current Interest Rate:": "當前年化利率：",
    "Exceed the quota": "超出額度",
    "Please go back to select an action you want to take.": "請您返回選擇相應的操作。",
    "Deposit Asset": "存入資產",
    "Available in Pool": "資金池餘額",
    "Enable Deposit for": "激活存入",
    "Insufficient balance": "餘額不足",
    "Repay Success!": "還款成功",
    "Repay Asset": "償還資金",
    "Enable Repay for": "激活償還",
    "Withdraw Asset": "提取資金",
    "The borrow or withdraw amount will make your account unhealthy, please try a smaller amount.": "該操作會使您的資產健康等級變為“不健康”，請您減少輸入的額度。",
    "Loan": "資產借貸",
    "UNHEALTHY": "不健康",
    "WARNING": "危險",
    "FAIR": "一般",
    "GOOD": "良",
    "VERY GOOD": "優",
    "Assets": "加密貨幣資產",
    "You can unwrap WBNB for BNB or wrap BNB for WBNB with no trading fees. Exchange rate is always 1 to 1.": "您可以在WBNB和BNB之間進行一比一的無手續費兌換。",
    "Save & Loan": "储蓄借贷",
    "GO TO SAVE & LOAN": "访问储蓄借贷",
    "Circulating Supply": "循環供應",
    "Your TIFI Balance": "您的TIFI余額",
    "TVL": "TVL",
    "Daily Trading Volume": "24小時內交易量",
    "Burnt": "已燃燒",
    "Holders": "持有人",
    "Stake TIFI for 180 days and Receive both TIFI and WBNB Rewards!": "質押TIFI180天以獲得高年利率的TIFI和WBNB回報!",
    "Amount to Unstake": "取出數量",
    "Cannot add address of": "無法添加該地址",
    "GO TO PLAY": "玩福袋",
    "GO TO CRYPTO LOAN": "加密借貸",
    "START EARNING": "開始創收",
    "Start Earning!": "開始創收!",
    "Lock To Earn": "鎖倉創收",
    "Lock to earn": "鎖倉創收",
    "Lock TiFi Token with fix period for high return": "將TiFi幣定期鎖倉得到高收益率收入。",
    "This exclusive program offers high returns (up to 100% of APR) for locking TiFi Token with fix period.": "該專屬方案使您通過定期鎖倉TiFi幣獲得高額回報（高至100%的年收益率）。",
    "Learn more": "了解更多！",
    "TVL in Staking Lock": "鎖倉總價值(TVL)",
    "Total TiFi Token Locked": "已鎖住TiFi幣的總數量",
    "Maximum APR": "最高年回報率",
    "Your Earning Records": "您的創收記錄",
    "100 % + Reflection": "100%加上反射獎勵",
    "The total value locked in US dollars.": "以美元為單位計算的資產鎖倉總價值。",
    "The total amount of TiFi Token locked in staking lock.": "在質押鎖中的TIFI總量",
    "The maximum APR you can get, you need follow the terms of lock to earn.": "鎖倉創收條款中的最高年回報率。",
    "Connect to a wallet to view your earning records.": "連接錢包以查看創收記錄。",
    "Time of Deposit": "存入時間",
    "Time of Maturity": "到期時間",
    "Principal": "本金",
    "Reflection Reward Till Now": "截止目前的反射獎勵",
    "Fix Rate Reward": "固定獎勵額",
    "You cannot withdraw or change the deposit until the time of maturity.": "在存款到期前您不能取出或者更改。",
    "By clicking the Withdraw button, you will receive ": "取出該存款後，您將會得到",
    "No lock record found": "暫無創收記錄",
    "Lock TiFi Token and Earn!": "將TiFi幣鎖倉來創收！",
    "Earning Terms (Click one row to start)": "創收條款（點擊下面的條款開始創收）：",
    "Enable Earning": "同意鎖倉創收",
    "Term Period": "期限",
    "Minimum Deposit (TIFI)": "最少存入數量（TIFI）",
    "APR": "年利率",
    "Review Earning Term": "確定創收條款",
    "You are going to deposit TiFi Tokens with the following term:": "您將會以以下條款存入TiFi幣：",
    "Deposit Amount: ": "存入數量：",
    "Deposit Period: ": "存入期限：",
    "Days": "天",
    "Reward: ": "創收利率：",
    " and reflection rewards": "加上反射獎勵",
    "By clicking the button below, I acknowledged that above terms cannot be changed AND I am not able to withdraw the principal or rewards during the period show above.": "一旦點擊下面的按鈕，我認可以上條款且該條款不會更改，而且我確定在以上所示的存入期限內我不能取出本金和利息。",
    "Accept and Deposit": "接受並繼續",
    "Approved! Now you can start earning.": "已同意，現在您可以鎖倉創收了！",
    "Transaction submitted! Please wait a few seconds for completion.": "交易已提交，耐心等待幾秒鐘後就會完成交易。",
    "Fiat Buy": "銀行卡買幣",
    "Visa & Mastercard": "銀行卡",
    "BUY WITH BANK CARDS": "用銀行卡購買",
    "Buy TiFi Token with Visa and Mastercard!": "使用Visa卡和萬事達卡買TiFi幣！"
}

export default zhtw;